export default __webpack_public_path__ + "static/media/blackseedbagels.1411b663.jpeg";